import Icon from 'atoms/icon'
import breakpoints from 'config/mediaBreakpoints'
import React, { useRef } from 'react'
import { useMediaQuery } from 'react-responsive'
import { useLocation } from 'react-router-dom'
import './login.css'
const background = require('assets/jpg/loginBG.png')
const mobileBackground = require('assets/jpg/loginBGMobile.png')
const Logo = require('!babel-loader!svg-react-loader?name=Logo!../../../assets/svg/global/2021Logo_blue.svg')
interface LoginProps {
  children?: JSX.Element[] | JSX.Element
}

export default (props: LoginProps): JSX.Element => {
  const elRef = useRef(null)

  const location = window.location.href

  const isMobile = useMediaQuery({
    maxWidth: breakpoints.smallerThanLoginCardWidth
  })

  return (
    <div
      className={`loginContainer ${location?.includes('secure-email-link') &&
        'emailLogin'}`}
      style={{
        backgroundImage: `url(${!isMobile ? background : mobileBackground})`
      }}
      ref={elRef}
    >
      <div className="loginTile">
        <Icon glyph={Logo} className="loginTileLogo" />
        <div className="loginTileForm">{props.children}</div>
      </div>
    </div>
  )
}
